import { fork, put, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import {
  LogControllerDtoRollRandomGemSocketsLogListRequest,
  PerplayLogApi,
} from '../../models/src';
import {
  GEMSOCKETLOG_LIST_REQUEST,
} from '../../constants/log/gemSocketLogConstants';
import LogControllerDtoRollRandomGemSocketsLogListResponse
  from '../../models/src/model/LogControllerDtoRollRandomGemSocketsLogListResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new PerplayLogApi(config.API_CLIENT);

function* gemSocketLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoRollRandomGemSocketsLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.walletTransactionNo = payload.walletTransactionNo;
    console.log('requestData: ', requestData);

    const result = yield api.apiPerplayLogRollRandomGemSocketsLogListPost({ logControllerDtoRollRandomGemSocketsLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoRollRandomGemSocketsLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* gemSocketLogReootSaga() {
  yield all([
    takeEvery(GEMSOCKETLOG_LIST_REQUEST, gemSocketLogListRequestSaga),
  ]);
}

const gemSocketLogSaga = [
  fork(gemSocketLogReootSaga),
]

export default gemSocketLogSaga;
